import React from 'react';
import {StyleProp, StyleSheet, Text, TextInput, TextStyle, View, ViewStyle} from 'react-native';
import {colors} from '../assets/styles/colors';

type Props = {
  value: string, onChange: (text: string) => void, length?: number, disabled?: boolean, secureTextEntry?: boolean,
  autoFocus?: boolean, accessibilityLabel?: string, containerStyle?: StyleProp<ViewStyle>,
  itemStyle?: StyleProp<ViewStyle>, filledItemStyle?: StyleProp<ViewStyle>, textStyle?: StyleProp<TextStyle>
};

const CodeVerificationInput = (props: Props) => {
  const {value, length = 6, disabled = false, secureTextEntry = true, autoFocus = true} = props;
  const {accessibilityLabel = 'Verification code', containerStyle, itemStyle, filledItemStyle, textStyle} = props;
  const normalizedValue = value.replace(/\D/g, '').slice(0, length);

  return (
    <View style={[styles.container, containerStyle]}>
      <View style={styles.items} accessible={false} accessibilityElementsHidden
            importantForAccessibility="no-hide-descendants">
        {Array.from({length}).map((_, index) => {
          const digit = normalizedValue[index] || '';

          return (
            <View key={index} style={[styles.item, itemStyle, !!digit && filledItemStyle]}>
              <Text style={[styles.text, textStyle]}>{digit ? secureTextEntry ? '•' : digit : ''}</Text>
            </View>
          );
        })}
      </View>

      <TextInput
        value={normalizedValue} onChangeText={text => props.onChange(text.replace(/\D/g, '').slice(0, length))}
        style={styles.input} keyboardType="number-pad" autoCorrect={false} editable={!disabled}
        accessibilityLabel={accessibilityLabel} autoFocus={autoFocus} caretHidden
        accessibilityState={{disabled}}
        selection={{start: normalizedValue.length, end: normalizedValue.length}}
        selectionColor="transparent" secureTextEntry={secureTextEntry}
        textContentType="oneTimeCode" autoComplete="one-time-code"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {position: 'relative', marginBottom: 30},
  items: {flexDirection: 'row', justifyContent: 'center'},
  item: {
    flex: 1, maxWidth: 59, height: 59, marginHorizontal: 3, borderRadius: 14, borderWidth: 1, justifyContent: 'center',
    borderColor: colors.settings_border, backgroundColor: colors.new_input_color, alignItems: 'center'
  },
  text: {color: colors.lightBlue, fontFamily: 'Barlow-Regular', fontSize: 18, textAlign: 'center'},
  input: {position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, color: 'transparent', opacity: 0}
});

export default React.memo(CodeVerificationInput);
